module.exports = __webpack_public_path__ + "img/bg_16x9@3x.23bb4b66.png";